import { render, staticRenderFns } from "./DeleteProducts.vue?vue&type=template&id=3191c90e&scoped=true&"
import script from "./DeleteProducts.vue?vue&type=script&lang=js&"
export * from "./DeleteProducts.vue?vue&type=script&lang=js&"
import style0 from "./DeleteProducts.vue?vue&type=style&index=0&id=3191c90e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3191c90e",
  null
  
)

export default component.exports